import { useContext } from "react"
import { RefreshTokenContext } from "../contexts/Refreshtoken"

export function useRefreshToken () {
  const value = useContext(RefreshTokenContext)

  return value
}